import { Share2, Bookmark, Check } from "lucide-react";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

interface ControlActionsProps {
    title: string;
    url?: string;
    hideSaveOnMobile?: boolean;
}

export default function ControlActions({ title, url, hideSaveOnMobile = false }: ControlActionsProps) {
    const [saved, setSaved] = useState(false);
    const [copied, setCopied] = useState(false);

    const handleShare = async () => {
        setSaved(false); // Exclusive toggle
        const shareUrl = url || window.location.href;
        try {
            await navigator.clipboard.writeText(shareUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };

    const handleSave = () => {
        setCopied(false); // Exclusive toggle
        setSaved(true);
        setTimeout(() => setSaved(false), 4000);
    };

    // Platform Detection for "Professional" specific hints
    const isMac = typeof navigator !== 'undefined' && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
    const shortcut = isMac ? "⌘ + D" : "CTRL + D";

    return (
        <div className="flex gap-3">
            {/* SHARE BUTTON */}
            <div className="relative">
                <AnimatePresence>
                    {copied && (
                        <motion.div
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: -45 }}
                            exit={{ opacity: 0 }}
                            className="absolute left-1/2 -translate-x-1/2 bg-emerald-500 text-black text-[11px] font-bold px-3 py-1.5 rounded-lg whitespace-nowrap pointer-events-none z-50 shadow-xl"
                        >
                            Link Kopyalandı!
                        </motion.div>
                    )}
                </AnimatePresence>

                <button
                    onClick={handleShare}
                    className={`h-[54px] w-[54px] flex items-center justify-center bg-[var(--card-bg)] rounded-[20px] transition-all duration-300 border-2 ${copied
                        ? "border-emerald-500 text-emerald-500 bg-emerald-500/10"
                        : "border-[#2A2A2A] text-gray-400 hover:text-white hover:border-[var(--accent)] hover:bg-[var(--accent)]/10"
                        }`}
                    title="Paylaş"
                >
                    {copied ? <Check size={20} /> : <Share2 size={20} />}
                </button>
            </div>

            {/* SAVE BUTTON */}
            <div className={`relative ${hideSaveOnMobile ? 'hidden sm:block' : ''}`}>
                <AnimatePresence>
                    {saved && (
                        <motion.div
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: -45 }}
                            exit={{ opacity: 0 }}
                            className="absolute left-1/2 -translate-x-1/2 bg-[var(--accent)] text-[#111] text-[11px] font-bold px-3 py-1.5 rounded-lg whitespace-nowrap pointer-events-none z-50 shadow-xl shadow-blue-500/20"
                        >
                            <span>Kaydetmek için {shortcut}</span>
                        </motion.div>
                    )}
                </AnimatePresence>
                <button
                    onClick={handleSave}
                    className={`h-[54px] w-[54px] flex items-center justify-center bg-[var(--card-bg)] border-2 rounded-[20px] transition-all duration-300 ${saved
                        ? "border-[var(--accent)] text-[var(--accent)] bg-[var(--accent)]/10"
                        : "border-[#2A2A2A] text-gray-400 hover:text-white hover:border-[var(--accent)] hover:bg-[var(--accent)]/10"
                        }`}
                    title="Favorilere Ekle"
                >
                    <Bookmark size={20} />
                </button>
            </div>
        </div>
    );
}
